import { media, styled } from '@pulse-web-ui/theme';

export const Container = styled.div<{
  $width?: number;
  $isAlignCenter?: boolean;
}>`
  width: ${({ $width }) => $width ?? 768}px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isAlignCenter }) => ($isAlignCenter ? 'center' : 'normal')};
  gap: 24px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  width: 100%;
  flex-shrink: 0;
  padding: 0 16px;
  ${media.desktop} {
    padding: 0;
  }
`;
